'use client';

import { __rest, __assign } from '../_virtual/_tslib.js';
import React__default, { forwardRef } from 'react';
import 'react-dom';
import '../hooks/useMakeSearchable/types.js';
import '../Utils/constants.js';
import '../services/resumes/types.js';
import useTransition from '../hooks/useTransition.js';
import { TooltipContainer } from './SimpleTooltip.css.js';

var Tooltip = forwardRef(function (_a, ref) {
    var content = _a.content, offsetHeight = _a.offsetHeight, show = _a.show, custom = _a.custom, restProps = __rest(_a, ["content", "offsetHeight", "show", "custom"]);
    var _b = custom || {}, _c = _b.maxWidth, maxWidth = _c === void 0 ? '300px' : _c, _d = _b.duration, duration = _d === void 0 ? 100 : _d;
    var _e = useTransition({ open: show }, {
        initial: {
            opacity: 0
        },
        enter: {
            opacity: 1
        },
        leave: {
            opacity: 0
        },
        duration: duration
    }), isMounted = _e.isMounted, styles = _e.styles;
    return isMounted ? (React__default.createElement(TooltipContainer, __assign({ maxWidth: maxWidth, offsetHeight: offsetHeight, style: styles, ref: ref }, restProps), content)) : (React__default.createElement(React__default.Fragment, null));
});

export { Tooltip as default };
//# sourceMappingURL=Tooltip.js.map
